import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';
import { CotizacionService } from 'src/app/core/http/apiPricing/cotizacion.service';
import { resetContract } from 'src/app/state/contracts/contracts.actions';
import { resetQuote, setQuote } from 'src/app/state/quotation/quotation.actions';
import { IQuotation } from 'src/app/state/quotation/quotation.models';
import { selectQuotation } from 'src/app/state/quotation/quotation.selectors';

@Component({
  selector: 'app-coverage-price-card',
  templateUrl: './coverage-price-card.component.html',
  styleUrls: ['./coverage-price-card.component.scss']
})
export class CoveragePriceCardComponent implements OnInit {

  @Input() isReadOnly: boolean;
  @Input() priceContract: number;

  quotation$: Observable<IQuotation>;


  constructor(
    private router: Router,
    private store: Store,
    private cotizacionService: CotizacionService,
  ) { }

  ngOnInit(): void {
    if (!this.isReadOnly) {
      this.store.dispatch(resetQuote())
    }
    
    this.quotation$ = this.store.select(selectQuotation);
  }

  goToContract() {
    this.quotation$.pipe(first()).subscribe(res => {
      this.cotizacionService.getCotizationList({idCotizacion: res.idCotizacion}).pipe(first()).subscribe(quote => {
        this.store.dispatch(setQuote({quote: quote.data[0]}))
        this.store.dispatch(resetContract())
        this.router.navigate(['/clientData']);
      })
    })
  }
}
